/**
 * @description router全局配置，如有必要可分文件抽离，其中asyncRoutes只有在intelligence模式下才会用到，pro版只支持remixIcon图标
 * hidden:true                        是否显示在菜单中显示路由（默认值：false）
 * alwaysShow:true                    当只有一级子路由时是否显示父路由是否显示在菜单中显示路由（默认值：false）
 * name:"Demo"                        首字母大写，一定要与vue文件的name对应起来，用于noKeepAlive缓存控制（该项特别重要）
 * meta:{
    title:"title"                     菜单、面包屑、多标签页显示的名称
    roles:["admin","..."]             当config/settings.js中rolesControl配置开启时，用于控制角色
    roles: {
      role: ["admin"],                role: ["admin"]
      ability: ["READ","WRITE"],      ability: ["READ","WRITE"],
      mode: "allOf"                   allOf: 数组内所有角色都拥有，返回True
                                      oneOf: 数组内拥有任一角色，返回True(等价第1种数据)
                                      except: 不拥有数组内任一角色，返回True(取反)
    }
    remixIcon:""                      remix图标
    isCustomSvgIcon:false,            是否是自定义svg图标（默认值：false，如果设置true，那么需要把你的svg拷贝到icon/remixIcon下，然后remixIcon字段配置上你的图标名）
    noKeepAlive:true                  当前路由是否不缓存（默认值：false）
    affix:true                        当前路由是否固定多标签页
    badge:"New"                       badge小标签（只支持子级）
    tagHidden:true                    当前路由是否不显示多标签页
   }
 */

/*
角色组说明
00000000-0000-0000-0000-000000000000 '0'	游客         属于BIM平台，但是设计中啥菜单也看不到的人
00000000-0000-0000-0000-000000000001 '1'	设计中心_领导          TP_WorkGroup

1.01  1.02  1.03 1.04  1.05   五个所的所长
00000000-0000-0000-0000-000000000002 '2'	设计中心_信息管理员     TP_WorkGroup
00000000-0000-0000-0000-000000000003 '3'	设计中心_技术经理   1.1    XMCH_OBSDef
00000000-0000-0000-0000-000000000004 '4'	设计中心_专业负责人  1.1.9    XMCH_OBSDef
00000000-0000-0000-0000-000000000005 '5'	设计中心_普通设校审人员   CZGL_staffArrang
00000000-0000-0000-0000-000000000106 '1.06'	 外部门来设计平台发产值的角色     TP_WorkGroup
00000000-0000-0000-0000-000000000106 '1.07'	 外部门来设计平台发产值的角色     TP_WorkGroup
*/

export const routesdata = [
  {
    path: '/',
    component: 'Layout',
    redirect: '/index',
    meta: {
      title: '工作台',
      remixIcon: 'home-3-line',
      affix: true,
    },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: '@/views/index',
        meta: {
          title: '首页',
          remixIcon: 'home-3-line',
          affix: true,
        },
      },
    ],
  },
  //流程**************************

  {
    path: '/flow',
    name: 'Flow',
    component: 'Layout',
    hidden: true,
    meta: {},
    children: [
      //设计OBS定义
      {
        path: '/02prjplan/obsdef-flow/:uniqueId',
        name: 'OBSdefFlow',
        component: '@/views/02prjplan/obsdef-flow',
        meta: {
          title: '设计OBS定义_流程',
          id: 'F1F5D256-51BB-41E9-9E9B-E5FE3F2ECD44',
        },
      },
      {
        path: '/02prjplan/obsdef-flow/:uniqueId',
        name: 'Flow_DD9B7662-83DA-46D4-A00D-73A5C6B60312',
        component: '@/views/02prjplan/obsdef-flow',
        meta: {
          title: '设计OBS定义_流程',
          id: 'F1F5D256-51BB-41E9-9E9B-E5FE3F2ECD44',
        },
      },
      {
        /// todo 待删除
        path: '/02prjplan/obsdef-flow-yg/:uniqueId',
        name: 'Flow_F1F5D256-51BB-41E9-9E9B-E5FE3F2ECD44',
        component: '@/views/02prjplan/obsdef-flow-yg',
        meta: {
          title: '设计OBS定义_流程_yg',
        },
      },
      {
        path: '/02prjplan/obsdef-flow-pmp/:uniqueId',
        name: 'OBSdefFlowPMP',
        component: '@/views/02prjplan/obsdef-flow-pmp',
        meta: {
          title: '设计OBS定义_流程-pmp',
          id: 'F1F5D256-51BB-41E9-9E9B-E5FE3F2ECD44',
        },
      },
      // {
      //   path: 'design-review-flow/:uniqueId',
      //   name: 'Flow_120CC2EF-5DCF-4CEB-8F89-97F79CF5EFAF',
      //   component: '@/views/04quality/designReview/form',
      //   meta: {
      //     title: '设计评审_流程',
      //   },
      // },
      {
        path: '/06pay/payClaim/form/:uniqueId',
        name: 'Flow_70904156-53DF-459E-847F-A5AF2491CA06',
        component: '@/views/06pay/payClaim/form',
        meta: {
          title: '产值申报明细_流程',
        },
      },

      {
        path: '/04quality/provdatumFlow1/:uniqueId',
        name: 'Flow_5FE0FBC7-A0A0-4A4F-B6CE-AC3177C7742E',
        component: '@/views/04quality/provdatum/flow',
        hidden: true,
        meta: {
          title: '协同提资-流程',
        },
      },
      {
        path: '/04quality/provdatumFlow2/:uniqueId',
        name: 'Flow_307E04D4-4279-4CD0-A177-0D58F7887694',
        component: '@/views/04quality/provdatum/flow',
        hidden: true,
        meta: {
          title: '协同提资-流程',
        },
      },
      {
        path: 'provdatumReview/:uniqueId',
        name: 'provdatum_review',
        component: '@/views/04quality/provdatum/review',
        hidden: true,
        meta: {
          title: '协同提资-校审',
        },
      },
      {
        path: 'provdatumReview/:uniqueId',
        name: 'provdatum_review_bim',
        component: '@/views/04quality/provdatum/review_bim',
        hidden: true,
        meta: {
          title: '协同提资-校审bim',
        },
      },
      {
        path: 'professionalReviewMain/:uniqueId',
        name: 'professionalReview_review',
        component: '@/views/04quality/professionalReview/review',
        hidden: true,
        meta: {
          title: '校审页面',
        },
      },
      {
        path: 'professionalReviewMain/:uniqueId',
        name: 'professionalReview_review_bim',
        component: '@/views/04quality/professionalReview/review_bim',
        hidden: true,
        meta: {
          title: '协同提资-校审bim',
        },
      },

      {
        path: '/11procedureManagement/professionReviewFlow/:uniqueId',
        name: 'Flow_C9E137CD-B2CD-4569-AB61-7837A530E9E2', //原 2D02C585-00DF-4FBB-93FE-FBA6B42B6D66
        component: '@/views/11procedureManagement/professionReview/flow',
        hidden: true,
        meta: {
          title: '车间图纸审批-流程',
        },
      },
      {
        path: '/11procedureManagment/zxprofessionalReviewWatch/:uniqueId',
        name: 'ZxprofessionalReviewWatch',
        component: '@/views/11procedureManagement/professionReview/flowWatch',
        hidden: true,
        meta: {
          title: '车间图纸审批-查看',
        },
      },
      {
        path: 'zxprofessionReviewMain/:uniqueId',
        name: 'zxprofessionReview_review',
        component: '@/views/11procedureManagement/professionReview/review',
        hidden: true,
        meta: {
          title: '车间图纸审批页面',
        },
      },
      {
        path: 'zxprofessionReviewMain/:uniqueId',
        name: 'zxprofessionReview_review_bim',
        component: '@/views/11procedureManagement/professionReview/review_bim',
        hidden: true,
        meta: {
          title: '车间图纸审批页面bim',
        },
      },
      {
        path: '/11procedureManagement/transferFileReviewFlow/:uniqueId',
        name: 'Flow_17453264-140D-4E40-AE61-CDF8118CA3FB',
        component: '@/views/11procedureManagement/professionReview/flow_projectTransfer',
        hidden: true,
        meta: {
          title: '文件传递审批-流程',
        },
      },
      {
        path: '/13countersign/countersignFlow/:uniqueId',
        name: 'Flow_58821D3F-AE5C-4588-AF29-6C416BD00888',
        component: '@/views/13countersign/form',
        hidden: true,
        meta: {
          title: '会签-流程',
        },
      },
      {
        path: '/13countersign/countersignReadonly/:uniqueId',
        name: 'countersignReadonly',
        component: '@/views/13countersign/formreadonly',
        hidden: true,
        meta: {
          title: '会签-查看',
        },
      },
      {
        path: '/13countersign/tablePrint/:uniqueId',
        name: 'countersigntablePrint',
        component: '@/views/13countersign/tablePrint',
        hidden: true,
        meta: {
          title: '会签-打印',
        },
      },
    ],
  },

  //基础数据 01basicdata
  {
    path: '/01basicdata',
    name: 'Basicdata',
    component: 'Layout',
    alwaysShow: true,
    // redirect: '/order/designdocument',
    meta: {
      title: '基础数据',
      remixIcon: 'settings-2-line',
      roles: ['1', '2'],
    },
    children: [
      {
        path: 'paytype',
        name: 'Paytype',
        component: '@/views/01basicdata/paytype',
        meta: {
          title: '绩效分类维护',
          remixIcon: 'bim',
          btnList: [1, 2, 3, 4],
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2'],
        },
      },
      {
        path: 'controlnode',
        name: 'Controlnode',
        component: '@/views/01basicdata/controlnode',
        meta: {
          title: '控制节点库',
          remixIcon: 'bim',
          btnList: [1, 2, 3, 4],
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2'],
        },
      },

      {
        path: 'docfolder',
        name: 'Docfolder',
        component: '@/views/01basicdata/docfolder',
        meta: {
          title: '文档管理模板',
          remixIcon: 'bim',
          btnList: [1, 2, 3, 4],
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2'],
        },
      },
      //majortemplate
      {
        path: 'majortemplate',
        name: 'Majortemplate',
        meta: {
          title: '专业模板',
          remixIcon: 'bim',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2'],
          isnewWin: 1,
          newWinPath:
            'http://bim.sinoma-tianjin.com:8091/ProgramBuilder/Run?programid=48c2dc86-4c52-4adc-9912-c266b7711be3&appid=1385f790-a8d6-4cfc-99b4-9142121bd1af&titlename=SN&title=fccce791-47b1-42bf-8650-ab80b1765659&instanceid=null&project=null&project1=null&project2=null&project3=null&project4=null&xmmc=%E6%B0%B4%E6%B3%A5&lan=',
        },
      },
      {
        path: 'drawstage',
        name: 'Drawstage',
        meta: {
          title: '施工图阶段库',
          remixIcon: 'bim',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2'],
          isnewWin: 1,
          newWinPath:
            'http://bim.sinoma-tianjin.com:8091/ProgramBuilder/RunJgrid?programid=59fa4679-5df9-45a2-bc8d-7ae563f6f67a&title=fccce791-47b1-42bf-8650-ab80b1765659&project1=5&project2=5',
        },
      },
      //shoptemplate
      {
        path: 'shoptemplate',
        name: 'Shoptemplate',
        // component: '@/views/01basicdata/shoptemplate',//彭妙培 弹出新窗口
        meta: {
          title: '车间模板',
          remixIcon: 'bim',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2'],
          isnewWin: 1,
          newWinPath:
            'http://bim.sinoma-tianjin.com:8091/Frame/Application?bs=051e4dd8-75c8-d3ff-b164-4d9dafbab022&appid=c8d0a37e-bab1-495a-b4f3-f48756c89c8a&tabid=tab_c8d0a37ebab1495ab4f3f48756c89c8a',
        },
      },
      {
        path: 'dictionary',
        name: 'Dictionary',
        component: '@/views/01basicdata/shoptemplate', //彭妙培 弹出新窗口
        meta: {
          title: '平台数据字典',
          remixIcon: 'bim',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2'],
          isnewWin: 1,
          newWinPath:
            process.env.VUE_APP_ROADFLOW_URL +
            '/TPMVC_Function/Dictionary/Index?appid=167E98F9-88C5-4C52-B1C8-67A16317C05A&TP_appopenmodel=0&tabid=tab_167E98F988C54C52B1C867A16317C05A',
        },
      },
    ],
  },
  //项目策划 02prjplan
  {
    path: '/02prjplan',
    name: 'Prjplan',
    component: 'Layout',
    alwaysShow: true,
    // redirect: '/order/designdocument',
    meta: {
      title: '项目策划',
      remixIcon: 'projector-line',
      roles: ['1', '2', '3', '4', '5', '1.06', '1.07'],
    },
    children: [
      {
        path: 'designprojectdef',
        name: 'Designprojectdef',
        component: '@/views/02prjplan/designprojectdef',
        alwaysShow: true,
        meta: {
          title: '设计项目定义',
          remixIcon: 'bim',
          roles: ['1', '2', '1.06', '1.07'],
        },
      },
      {
        path: 'obsdef',
        name: 'OBSdef',
        component: '@/views/02prjplan/obsdef',
        alwaysShow: true,
        meta: {
          title: '设计OBS定义',
          remixIcon: 'bim',
          roles: ['1', '2', '3', '1.06', '1.07'],
        },
      },
      {
        path: 'obsdefflowedit',
        name: 'Flow_ObsDefFlowEdit',
        component: '@/views/02prjplan/obsdef-flow-edit',
        hidden: true,
        meta: {
          title: '设计OBS定义-编辑',
          remixIcon: 'bim',
        },
      },
      {
        path: 'shopdef',
        name: 'Shopdef',
        component: '@/views/02prjplan/shopdef',
        meta: {
          title: '项目车间维护',
          remixIcon: 'bim',
          roles: ['1', '2', '3'],
        },
      },
      {
        path: 'wbsdef',
        name: 'WBSdef',
        component: '@/views/02prjplan/wbsdef',
        meta: {
          title: '设计WBS定义',
          remixIcon: 'bim',
          roles: ['1', '2', '3', '4'],
        },
      },
    ],
  },
  //进度管理 03plustask
  {
    path: '/03plustask',
    name: 'Plustask',
    component: 'Layout',
    alwaysShow: true,
    meta: {
      title: '进度管理',
      remixIcon: 'timer-2-line',
      roles: ['1', '2', '3', '4', '5'],
    },
    children: [
      {
        path: 'gantt',
        name: 'Gantt',
        component: '@/views/03plustask/gantt',
        meta: {
          title: '设计进度管理',
          remixIcon: 'bar-chart-horizontal-fill',
          roles: ['1', '2', '3', '4', '5', '1.7', '1.12'],
        },
      },
    ],
  },
  //质量管理 04quality
  {
    path: '/04quality',
    name: 'Quality',
    component: 'Layout',
    alwaysShow: true,
    // redirect: '/order/designdocument',
    meta: {
      title: '质量管理',
      remixIcon: 'draft-fill', //draft-fill  mark-pen-line
      roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
    },
    children: [
      // {
      //   path: 'qualityplan',
      //   name: 'QualityPlan',
      //   component: '@/views/04quality/qualityplan',
      //   meta: {
      //     title: '质量控制计划',
      //     remixIcon: 'bim',
      //     roles: ['1','1.01','1.02','1.03', '2', '3', '4', '5'],
      //   },
      // },
      {
        path: 'designreview',
        name: 'DesignReview',
        component: '@/views/04quality/designReview/index',
        meta: {
          title: '设计评审',
          remixIcon: 'blank',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
          type: '.01PS',
        },
      },
      {
        path: 'design-review-flow/:uniqueId',
        name: 'Flow_120CC2EF-5DCF-4CEB-8F89-97F79CF5EFAF',
        component: '@/views/04quality/designReview/form',
        hidden: true,
        meta: {
          title: '设计评审_流程',
        },
      },

      {
        path: 'professionalReviewWatch',
        name: 'professionalReviewWatch',
        component: '@/views/04quality/professionalReview/flowWatch',
        hidden: true,
        meta: {
          title: '专业校审-查看',
        },
      },
      {
        path: 'professionalReview',
        name: 'ProfessionalReview',
        component: '@/views/04quality/professionalReview/index',
        meta: {
          remixIcon: 'bim',
          title: '专业校审',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
          remixIcon: 'blank',
          type: '.05SJ',
        },
      },
      {
        path: 'provdatum',
        name: 'Provdatum',
        component: '@/views/04quality/provdatum/index',
        meta: {
          remixIcon: 'bim',
          title: '协同提资/查返',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
          remixIcon: 'blank',
          type: '.10TZ',
        },
      },

      {
        path: 'provdatumFlowWatch',
        name: 'provdatumFlowWatch',
        component: '@/views/04quality/provdatum/flowWatch',
        hidden: true,
        meta: {
          title: '协同提资-查看',
          remixIcon: 'blank',
        },
      },

      {
        path: 'stageProductSubmission',
        name: 'StageProductSubmission',
        component: '@/views/04quality/stageProductSubmission/stageProductSubmission',
        meta: {
          title: '阶段成品提交',
          remixIcon: 'blank',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
          type: '.15CP',
        },
      },
      {
        path: 'stageProductSubmissionFlow',
        name: 'Flow_E2575DA6-DD59-4303-BDCE-DCA3951E409A',
        component: '@/views/04quality/stageProductSubmission/flow',
        hidden: true,
        meta: {
          title: '阶段成品提交-流程',
          remixIcon: 'blank',
        },
      },
      {
        path: 'finishedFile',
        name: 'FinishedFile',
        component: '@/views/04quality/finishedFile',
        meta: {
          title: '阶段成品归档',
          remixIcon: 'bim',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
        },
      },
      {
        path: 'changemng',
        name: 'ChangeMng',
        alwaysShow: true,
        // component: 'Layout',
        component: '04quality/changemng/index',
        redirect: '/04quality/changemng/meansChangeOrder',
        meta: {
          title: '设计更改',
          remixIcon: 'bim',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
        },
        children: [
          {
            path: 'meansChangeOrder',
            name: 'MeansChangeOrder',
            component: '04quality/changemng/meansChangeOrder',
            meta: {
              title: '资料变更单 ',
              remixIcon: 'bim',
              isLink: '',
              isHide: false,
              isKeepAlive: true,
              isAffix: false,
              isIframe: false,
              roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
            },
          },
          {
            path: 'meansChangeOrderFlow',
            name: 'Flow_953D81A7-1EC0-4B09-A6B9-F7F71D35433A',
            component: '04quality/changemng/meansChangeOrderflow',
            hidden: true,
            meta: {
              title: '资料变更单-流程',
              remixIcon: 'bim',
            },
          },
          {
            path: 'designChangeOrder',
            name: 'DesignChangeOrder',
            component: '04quality/changemng/designChangeOrder',
            meta: {
              title: '设计变更通知单 ',
              remixIcon: 'bim',
              isLink: '',
              isHide: false,
              isKeepAlive: true,
              isAffix: false,
              isIframe: false,
              roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
            },
          },
          {
            path: 'designChangeOrderFlow',
            name: 'Flow_FCE1C973-36E5-426B-8810-C1E1804B2439',
            component: '04quality/changemng/designChangeOrderflow',
            hidden: true,
            meta: {
              title: '设计变更通知单-流程',
              remixIcon: 'bim',
            },
          },
          {
            path: 'designContactOrder',
            name: 'DesignContactOrder',
            component: '04quality/changemng/designContactOrder',
            meta: {
              title: '*设计联系单 ',
              remixIcon: 'bim',
              isLink: '',
              isHide: false,
              isKeepAlive: true,
              isAffix: false,
              isIframe: false,
              roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
            },
          },
          {
            path: 'designContactOrderFlow',
            name: 'Flow_E41EF999-5CF8-435B-AA42-70048671D75A',
            component: '04quality/changemng/designContactOrderflow',
            hidden: true,
            meta: {
              title: '设计联系单-流程',
              remixIcon: 'bim',
            },
          },
          {
            path: 'designChangeApplicationOrder',
            name: 'DesignChangeApplicationOrder',
            component: '04quality/changemng/designChangeApplicationOrder',
            meta: {
              title: '设计更改申请表 ',
              remixIcon: 'bim',
              isLink: '',
              isHide: false,
              isKeepAlive: true,
              isAffix: false,
              isIframe: false,
              roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
            },
          },
          {
            path: 'designChangeApplicationOrderFlow',
            name: 'Flow_22A90AE0-E646-4AC7-98DF-DA10D9B11459',
            component: '04quality/changemng/designChangeApplicationOrderflow',
            hidden: true,
            meta: {
              title: '设计更改申请表-流程',
              remixIcon: 'bim',
            },
          },
        ],
      },
    ],
  },
  // {
  //   path: 'PID',
  //   name: 'PID',
  //   meta: {
  //     title: 'PID与请购管理',
  //     remixIcon: 'logout-box-line',
  //     //roles: ['1','1.01','1.02','1.03', '2'],
  //     isnewWin: 1,
  //     newWinPath: 'http://bim.sinoma-tianjin.com:8091/Eng/Home',
  //     roles: [],
  //   },
  // },
  {
    path: 'marketPrePrj',
    name: 'marketPrePrj',
    meta: {
      title: '前期报价配合',
      remixIcon: 'logout-box-line',
      //roles: ['1','1.01','1.02','1.03', '2'],
      isnewWin: 1,
      newWinPath: 'http://bim.sinoma-tianjin.com:8091/Marketing/Home',
      roles: [],
    },
  },
  {
    path: 'projectQuota',
    name: 'projectQuota',
    meta: {
      title: '工程平台报价版本',
      remixIcon: 'logout-box-line',
      isnewWin: 1,
      newWinPath: 'http://39.106.185.160:32004/#/quota/quotationVersion',
      roles: [],
    },
  },
  //人员管理 05person
  {
    path: '/05person',
    name: 'Person',
    component: 'Layout',
    alwaysShow: true,
    // redirect: '/order/designdocument',
    meta: {
      title: '人员管理',
      remixIcon: 'group-line',
      roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
    },
    children: [
      {
        path: 'staffarrang',
        name: 'StaffArrang',
        component: '@/views/05person/staffarrang',
        meta: {
          title: '项目人员配置',
          remixIcon: 'bim',
          roles: ['1', '2', '3', '4'],
        },
      },
      {
        path: 'persontasks',
        name: 'PersonPaySum',
        component: '@/views/06pay/personpaysum',
        meta: {
          title: '个人任务信息监控',
          remixIcon: 'bim',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
        },
      },
    ],
  },

  //绩效产值管理 06pay
  {
    path: '/06pay',
    name: 'Pay',
    component: 'Layout',
    alwaysShow: true,
    // redirect: '/order/designdocument',
    meta: {
      title: '绩效产值管理',
      remixIcon: 'swap-box-line',
      roles: ['0', '1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5', '1.06', '1.07'],
    },
    children: [
      {
        path: 'performancelocking',
        name: 'Performancelocking',
        component: '@/views/06pay/performancelocking',
        meta: {
          title: '绩效申报锁定', //领导
          remixIcon: 'bim',
          roles: ['1', '2'],
        },
      },
      {
        path: 'payproject',
        name: 'PayProject',
        component: '@/views/06pay/payproject',
        meta: {
          title: '项目产值分解', //1领导+2技术经理
          remixIcon: 'bim',
          btnList: [1, 2, 3, 4],
          roles: ['1', '2', '3', '1.06', '1.07'],
        },
      },
      {
        path: 'majorproject',
        name: 'MajorProject',
        component: '@/views/06pay/majorproject',
        meta: {
          title: '专业产值分配',
          remixIcon: 'bim',
          roles: ['1', '2', '3', '1.06', '1.07'], //>=技术经理
        },
      },
      {
        path: 'paydetails',
        name: 'PayDetails',
        component: '@/views/06pay/paydetails',
        meta: {
          title: '详细产值分配', //专业负责人
          remixIcon: 'bim',
          roles: ['1', '2', '3', '4', '1.06', '1.07'], //>=专业负责人
        },
      },
      {
        path: 'payclaim',
        name: 'PayClaim',
        component: '@/views/06pay/payClaim/payclaim',
        meta: {
          title: '月产值明细申报',
          remixIcon: 'mail-send-line',
          roles: ['1', '2', '3', '4', '1.06', '1.07'],
        },
      },

      {
        path: 'payreport',
        name: 'PayReport',
        component: '@/views/06pay/payreport',
        redirect: '/index',
        meta: {
          title: '产值统计',
          remixIcon: 'file-chart-line',
          roles: ['0', '1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
        },
        children: [
          {
            path: 'prjpayhistory',
            name: 'PrjPayHistory',
            component: '@/views/06pay/payreport/prjpayhistory',
            meta: {
              title: '项目发放历史',
              remixIcon: 'projector-line',
              roles: ['1', '2', '3', '1.06', '1.07'],
            },
          },
          // {
          //   path: 'prjpaysum',
          //   name: 'PrjPaySum',
          //   component: '@/views/06pay/prjpaysum',
          //   meta: {
          //     title: '02项目申请汇总',
          //     remixIcon: 'bim',
          //     btnList: [1, 2, 3, 4],
          //   },
          // },
          {
            path: 'monthvaluesummary',
            name: 'Monthvaluesummary',
            component: '@/views/06pay/monthvaluesummary/monthvaluesummary',
            meta: {
              title: '部门月产值汇总', //todo
              remixIcon: 'organization-chart', //organization-chart
              // roles: ['1', '2', '1.01', '1.02', '1.03', '1.04', '1.05'],// todo  部门领导只能看见自己的产值
              roles: ['1', '2'],
            },
          },
          {
            path: 'majorpaysum',
            name: 'MajorPaySum',
            component: '@/views/06pay/majorpaysum',
            meta: {
              title: '专业月产值发放',
              remixIcon: 'bim',
              roles: ['1', '2', '3', '1.06', '1.07'], //彭妙培  20220114 这里认为专业负责人暂不使用 todo
            },
          },

          {
            path: 'personpaysum',
            name: 'PersonPaySum',
            component: '@/views/06pay/personpaysum',
            meta: {
              title: '人员产值详情',
              remixIcon: 'team-line',
              roles: ['1', '2', '3', '4'],
            },
          },
          {
            path: 'personpaymonthsum',
            name: 'PersonPayMonthSum',
            component: '@/views/06pay/personpaymonthsum',
            meta: {
              title: '人员月度产值汇总',
              remixIcon: 'contacts-line',
              roles: ['0', '1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
              //  roles: ['1', '2'],
            },
          },
        ],
      },
      // {
      //   path: 'ordermanagement',
      //   name: 'Ordermanagement',
      //   component: '@/views/order/order-management',
      //   meta: {
      //     title: '测试页面',
      //     remixIcon: 'bim',
      //   },
      // },
    ],
  },
  //文档管理 10docmanagement
  {
    path: '/10docmanagement',
    name: 'Docmanagement',
    component: 'Layout',
    alwaysShow: true,
    meta: {
      title: '文档管理',
      remixIcon: 'file-history-line',
      roles: ['0', '1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
    },
    children: [
      {
        path: '/documentManagement',
        name: 'DocumentManagement',
        component: '@/views/10docmanagement/documentManagement',
        meta: {
          title: '设计文件留档',
          remixIcon: 'file-history-line',
          roles: ['0', '1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5'],
        },
      },
    ],
  },

  //质量管理 11procedureManagment
  {
    path: '/11procedureManagment',
    name: '11procedureManagment',
    component: 'Layout',
    alwaysShow: true,
    // redirect: '/order/designdocument',
    meta: {
      title: '咨询过程管理',
      remixIcon: 'command-fill',
    },
    children: [
      // {
      //   path: 'zxprofessionalReviewWatch',
      //   name: 'zxprofessionalReviewWatch',
      //   component: '@/views/11procedureManagement/professionReview/flowWatch.vue',
      //   hidden: true,
      //   meta: {
      //     title: '车间图纸审批-查看',
      //   },
      // },

      {
        path: 'zxProjectFileTransfer',
        name: 'ZxProjectFileTransfer',
        component: '@/views/11procedureManagement/professionReview/projectFileTransfer.vue',
        meta: {
          // remixIcon: 'bim',
          title: '项目文件传递',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5', '1.7', '1.12'],
          // remixIcon: 'blank',
        },
      },
      {
        path: '/04quality/professionalReviewFlow/:uniqueId',
        name: 'Flow_47BD3D13-A7FF-44B5-8878-9022C8EDEBC8',
        component: '@/views/04quality/professionalReview/flow',
        hidden: true,
        meta: {
          title: '专业校审-流程',
        },
      },

      {
        path: 'zxprofessionalReview',
        name: 'ZxprofessionalReview',
        component: '@/views/11procedureManagement/professionReview/index.vue',
        meta: {
          // remixIcon: 'bim',
          title: '车间图纸审批',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5', '1.7', '1.12'],
          // remixIcon: 'blank',
          type: '.ZX_05SJ',
        },
      },
      {
        path: '/drawStatusQuery',
        name: 'DrawStatusQuery',
        component: '@/views/11consult/drawStatusQuery',
        meta: {
          remixIcon: 'folder-history-line',
          title: '图纸审批状态查询',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5', '1.7', '1.12'],
          // remixIcon: 'shopping-basket-line',
        },
      },
      {
        path: '/consultDocSummary',
        name: 'ConsultDocSummary',
        component: '@/views/11consult/consultDocSummary',
        meta: {
          remixIcon: 'file-list-2-line',
          title: '咨询文档汇总',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5', '1.7', '1.12'],
          // remixIcon: 'shopping-basket-line',
        },
      },
      {
        path: '/approvedDrawingSummary',
        name: 'ApprovedDrawingSummary',
        component: '@/views/11consult/approvedDrawingSummary',
        meta: {
          title: '审批通过图纸汇总',
          remixIcon: 'task-line',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5', '1.7', '1.12'],
          // remixIcon: 'shopping-basket-line',
        },
      },
      {
        path: '/countersign',
        name: 'Countersign',
        component: '@/views/13countersign/index.vue',
        meta: {
          title: '会签',
          roles: ['1', '1.01', '1.02', '1.03', '1.04', '1.05', '2', '3', '4', '5', '1.7', '1.12'],
          // remixIcon: 'shopping-basket-line',
          type: '.ZX_05SJ',
        },
      },
    ],
  },
  {
    path: '/12equilist',
    name: 'Equiplist',
    component: 'Layout',
    alwaysShow: true,
    meta: {
      title: '设备表',
      remixIcon: 'timer-2-line',
    },
    children: [
      {
        path: 'equip',
        name: 'Equip',
        component: '@/views/12equip/equip',
        meta: {
          title: '专业大类配置',
          remixIcon: 'bar-chart-horizontal-fill',
        },
      },
      {
        path: 'equippara',
        name: 'Equippara',
        component: '@/views/12equip/equippara',
        meta: {
          title: '设备参数配置',
          remixIcon: 'bar-chart-horizontal-fill',
        },
      },
      {
        path: 'equiplistedit',
        name: 'Equiplistedit',
        component: '@/views/12equip/equiplistedit',
        meta: {
          title: '设备表编辑',
          remixIcon: 'bar-chart-horizontal-fill',
        },
      },
    ],
  },
  //demo  组件使用示例
  // {
  //   path: '/demo',
  //   name: 'Demo',
  //   component: 'Layout',
  //   alwaysShow: true,
  //   meta: {
  //     title: 'Demo路由权限测试',
  //     remixIcon: 'shopping-basket-line',
  //   },
  //   children: [
  //     {
  //       path: '/SelectTreeDemo1',
  //       name: 'SelectTreeDemo1',
  //       component: '@/views/demo/selectTreeDemo',
  //       meta: {
  //         title: 'SelectTreeDemo[1可见]',
  //         remixIcon: 'shopping-basket-line',
  //         roles: ['1'],
  //       },
  //     },
  //     {
  //       path: '/treetransferDemo',
  //       name: 'TeetransferDemo',
  //       component: '@/views/demo/treetransferDemo',
  //       meta: {
  //         title: 'TeetransferDemo[5可见]',
  //         remixIcon: 'shopping-basket-line',
  //         roles: ['1','1.01','1.02','1.03', '5'],
  //       },
  //     },
  //     {
  //       path: 'flowProcessDemo',
  //       name: 'flowProcessDemo',
  //       component: '@/views/demo/FlowProcessViewDemo',
  //       meta: {
  //         title: 'FlowProcessViewDemo[0可见]',
  //       },
  //     },
  //   ],
  // },
  //'/404
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
  {
    path: '*',
    redirect: '/FlowTest',
    hidden: true,
  },
];

export function dataFn() {
  return new Promise((resovle) => {
    resovle(routesdata);
  });
}
